import imgOnload from '../base/imgOnload'
import imgSetSrc from '../base/imgSetSrc'
import splitter from '../components/splitter'

const anim = {

  basic : function($el, delay = 0){

    let tl = new gsap.timeline()

    gsap.killTweensOf([
      $el.find('.reveal-line'),
      $el.find('.reveal-slider'),
      $el.find('.reveal-fade'),
      $el.find('.reveal-fadeup')
    ])

    // lines
    $el.find('.reveal-line').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      let split = new splitter($self)
      gsap.set($self.find('.splittext--line'), {overflow:'hidden'})
      $self.find('.splittext--linein').each(function(i){
        tl.fromTo($(this), 1.2, {y:'110%', autoAlpha:1}, {y:'0%', autoAlpha:1, ease:'expo.out'}, del + 0.2 * i)
      })
      tl.call(function(){
        split.revert()
      })
    })

    // srcimage
    $el.find('.reveal-loadimg').each(function(){
      const $self = $(this)
      gsap.killTweensOf($self)
      const $img = $self.is('img') ? $self : $self.find('img')
      gsap.set($self, {alpha:0})

      let del = $self.attr('data-reveal-delay') || 0

      let canReveal = false
      setTimeout(function(){
        canReveal = true
      }, del*1000)

      function doAnim(){
        if (canReveal) {
          gsap.fromTo($self, 2, {alpha:0, scale:1}, {alpha:1, scale:1, ease:'power2.out'})
        } else {
          setTimeout(function(){
            requestAnimationFrame(doAnim)
          }, 1000/10)
        }
      }

      imgOnload($img, function(){
        doAnim()
      })
      imgSetSrc($img)
    })

    $el.find('.reveal-scalefade').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      tl.fromTo($self, 1.2, {scale:1.1, autoAlpha:0}, {scale:1, autoAlpha:1, ease:'power3.inOut'}, del)
    })
    $el.find('.reveal-scaleupfade').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      tl.fromTo($self, 1.2, {scale:0.9, autoAlpha:0}, {scale:1, autoAlpha:1, ease:'power3.inOut'}, del)
    })

    // fade
    $el.find('.reveal-fade').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      tl.fromTo($self, 1.6, {autoAlpha:0}, {autoAlpha:1, ease:'power2.out'}, del)
    })
    $el.find('.reveal-fadeup').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      tl.fromTo($self, 1.6, {y:20, autoAlpha:0}, {y:0, autoAlpha:1, ease:'power4.out'}, del)
    })

  },


  card : function($el, delay = 0){

    let tl = new gsap.timeline()

    gsap.killTweensOf([
      $el.find('.reveal-cardline'),
      $el.find('.reveal-cardslider'),
      $el.find('.reveal-cardfade'),
      $el.find('.reveal-cardfadeup')
    ])

    // lines
    $el.find('.reveal-cardline').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      let split = new splitter($self)
      gsap.set($self.find('.splittext--line'), {overflow:'hidden'})
      $self.find('.splittext--linein').each(function(i){
        tl.fromTo($(this), 1.2, {y:'110%', autoAlpha:1}, {y:'0%', autoAlpha:1, ease:'expo.out'}, del + 0.2 * i)
      })
      tl.call(function(){
        split.revert()
      })
    })

    // srcimage
    $el.find('.reveal-cardloadimg').each(function(){
      const $self = $(this)
      gsap.killTweensOf($self)
      const $img = $self.is('img') ? $self : $self.find('img')
      gsap.set($self, {alpha:0})

      let del = $self.attr('data-reveal-delay') || 0

      let canReveal = false
      setTimeout(function(){
        canReveal = true
      }, del*1000)

      function doAnim(){
        if (canReveal) {
          gsap.fromTo($self, 2, {alpha:0, scale:1}, {alpha:1, scale:1, ease:'power2.out'})
        } else {
          setTimeout(function(){
            requestAnimationFrame(doAnim)
          }, 1000/10)
        }
      }

      imgOnload($img, function(){
        doAnim()
      })
      imgSetSrc($img)
    })

    $el.find('.reveal-cardscalefade').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      tl.fromTo($self, 1.2, {scale:1.1, autoAlpha:0}, {scale:1, autoAlpha:1, ease:'power3.inOut'}, del)
    })
    $el.find('.reveal-cardscaleupfade').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      tl.fromTo($self, 1.2, {scale:0.9, autoAlpha:0}, {scale:1, autoAlpha:1, ease:'power3.inOut'}, del)
    })

    // fade
    $el.find('.reveal-cardfade').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      tl.fromTo($self, 1.6, {autoAlpha:0}, {autoAlpha:1, ease:'power2.out'}, del)
    })
    $el.find('.reveal-cardfadeup').each(function(){
      let $self = $(this)
      let del = $self.attr('data-reveal-delay') || 0
      tl.fromTo($self, 1.6, {y:20, autoAlpha:0}, {y:0, autoAlpha:1, ease:'power4.out'}, del)
    })

  },

  scrollReveal : function($el, from){
    $el.addClass('js-visible')

    let del = 0
    if (from === 'fromPageEnter') {
      del = 0.75
    }

    let animType = $el.attr('data-reveal')
    if (animType === 'basic') {
      anim.basic($el, del)
    } else if (animType === 'card') {
      anim.card($el, del)
    }
  }
}

export default anim